import { TextInputField } from './TextInputField';
import type { FormFieldComponent } from './types';
import { fieldRule, readFormField } from './useFormField';

const ROLE = 'genericInputField';
const FALLBACK_NAME = 'emailAddress';

const GenericFormEmailInputField: FormFieldComponent = () => (
  <TextInputField role={ROLE} fallbackName={FALLBACK_NAME} type="email" multiline={false} />
);

GenericFormEmailInputField.formSchema = content => fieldRule(readFormField(content, 'genericFields', ROLE), FALLBACK_NAME);

export default GenericFormEmailInputField;
